import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { StandardService } from 'pages/standard-setup/standards/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(StandardService, DialogService, EventAggregator)
export class StandardConfigs {
    constructor(standardService, dialogService, ea) {
        this.ea = ea;
        this.standardService = standardService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'workCenter', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('standard-config:updated', () => {
            this.grid.refresh();
        });
    }

    async activate (params) {
        this.standardNumberId = params.id;
        this.standardNumber = await this.standardService.getById(this.standardNumberId);
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (standard) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.standardService.deleteConfig(this.standardNumberId, standard.id);
                this.grid.refresh();
                toastr.success('Standard configuration was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.standardService.configEditor, model: { standardNumberId: this.standardNumberId } });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.standardService.configEditor, model: { standardNumberId: this.standardNumberId, id: data.id } });
    };
}